// extracted by mini-css-extract-plugin
export default {"section":"styles_section__Udklz","icon":"styles_icon__f5e4w","heading":"styles_heading__0Bvoq","para":"styles_para__--BZN"};